export type Scale = "small" | "medium" | "big" | "huge" | "gigantic";

export type PassedProps = {
  scale?: Scale;
  isQuadratic?: boolean;
  children?: React.ReactNode;
};

export type MappedProps = {
  height?: number;
  width?: number;
  style: object;
};

const getSize = (scale?: Scale) => {
  switch (scale) {
    case "small":
      return 16;
    case "medium":
      return 32;
    case "huge":
      return 128;
    case "gigantic":
      return 256;
    case "big":
    default:
      return 64;
  }
};

export const useMappedProps = ({
  isQuadratic,
  scale,
  ...rest
}: PassedProps): MappedProps => ({
  ...rest,
  // we overwrite height and width with undefined as the svgr loader otherwise
  // sets them to 1em making the icon square rather than just having the
  // dimensions of the insurer logo
  height: isQuadratic ? getSize(scale) : undefined,
  style: {
    maxHeight: `${isQuadratic ? getSize(scale) : getSize(scale) / 2}px`,
    maxWidth: `${getSize(scale)}px`,
    // The height has to be specified after the maxHeight
    height: "100%",
    width: "100%",
  },
  width: isQuadratic ? getSize(scale) : undefined,
});
